// extracted by mini-css-extract-plugin
module.exports = {"row":"📦SampleHistoryItem__row--4Ncu5","time":"📦SampleHistoryItem__time--3YfB1"};